export default __webpack_public_path__ + "static/media/english-icon.7be3d5a2.png";